import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

const WEEK_DAY_OPTIONS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
]

const MONTH_DAY_OPTIONS = Array.from({ length: 28 }, (_, index) => ({
  value: index + 1,
  label: String(index + 1),
}))

const FREQUENCY_OPTIONS = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
]

const padTimeUnit = (value) => String(value).padStart(2, '0')

export const DEFAULT_SAVED_REPORT_SCHEDULE = {
  enabled: false,
  frequency: 'daily',
  dayOfWeek: 1,
  dayOfMonth: 1,
  hour: 8,
  minute: 0,
  timezone: 'America/New_York',
  email: '',
}

export const toTimeInputValue = (hour, minute) =>
  `${padTimeUnit(hour)}:${padTimeUnit(minute)}`

export const parseTimeInputValue = (value) => {
  const [hourPart, minutePart] = String(value || '').split(':')
  const hour = Number.parseInt(hourPart, 10)
  const minute = Number.parseInt(minutePart, 10)
  return {
    hour: Number.isFinite(hour) ? hour : DEFAULT_SAVED_REPORT_SCHEDULE.hour,
    minute: Number.isFinite(minute)
      ? minute
      : DEFAULT_SAVED_REPORT_SCHEDULE.minute,
  }
}

export default function SavedReportScheduleFields({
  schedule,
  onChange,
  disabled = false,
}) {
  const deliveryTimeValue = toTimeInputValue(schedule.hour, schedule.minute)

  return (
    <div className="saved-report-schedule mt-3">
      <Form.Check
        type="switch"
        id="saved-report-email-enabled"
        label="Email this report on a schedule"
        checked={Boolean(schedule.enabled)}
        disabled={disabled}
        onChange={(e) =>
          onChange({
            ...schedule,
            enabled: e.target.checked,
          })
        }
      />

      {schedule.enabled && (
        <Row className="g-3 mt-1">
          <Col md={6}>
            <Form.Group controlId="savedReportFrequency">
              <Form.Label className="uppercase text-body-xs font-weight-bold">
                Frequency
              </Form.Label>
              <Form.Select
                className="form-control-height"
                value={schedule.frequency}
                disabled={disabled}
                onChange={(e) =>
                  onChange({ ...schedule, frequency: e.target.value })
                }
              >
                {FREQUENCY_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {schedule.frequency === 'weekly' && (
            <Col md={6}>
              <Form.Group controlId="savedReportDayOfWeek">
                <Form.Label className="uppercase text-body-xs font-weight-bold">
                  Day of week
                </Form.Label>
                <Form.Select
                  className="form-control-height"
                  value={schedule.dayOfWeek}
                  disabled={disabled}
                  onChange={(e) =>
                    onChange({
                      ...schedule,
                      dayOfWeek: Number(e.target.value),
                    })
                  }
                >
                  {WEEK_DAY_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          {(schedule.frequency === 'monthly' ||
            schedule.frequency === 'quarterly') && (
            <Col md={6}>
              <Form.Group controlId="savedReportDayOfMonth">
                <Form.Label className="uppercase text-body-xs font-weight-bold">
                  {schedule.frequency === 'quarterly'
                    ? 'Day of quarter start month'
                    : 'Day of month'}
                </Form.Label>
                <Form.Select
                  className="form-control-height"
                  value={schedule.dayOfMonth}
                  disabled={disabled}
                  onChange={(e) =>
                    onChange({
                      ...schedule,
                      dayOfMonth: Number(e.target.value),
                    })
                  }
                >
                  {MONTH_DAY_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          )}

          <Col md={6}>
            <Form.Group controlId="savedReportTime">
              <Form.Label className="uppercase text-body-xs font-weight-bold">
                Delivery time
              </Form.Label>
              <Form.Control
                type="time"
                className="form-control-height"
                value={deliveryTimeValue}
                disabled={disabled}
                onChange={(e) => {
                  const { hour, minute } = parseTimeInputValue(e.target.value)
                  onChange({ ...schedule, hour, minute })
                }}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="savedReportEmail">
              <Form.Label className="uppercase text-body-xs font-weight-bold">
                Email
              </Form.Label>
              <Form.Control
                type="email"
                className="form-control-height"
                value={schedule.email || ''}
                disabled={disabled}
                onChange={(e) =>
                  onChange({ ...schedule, email: e.target.value })
                }
                placeholder="you@example.com"
              />
            </Form.Group>
          </Col>

          <Col xs={12}>
            <p className="text-muted small mb-0">
              Scheduled emails cover the previous{' '}
              {schedule.frequency === 'daily'
                ? 'day'
                : schedule.frequency === 'weekly'
                  ? 'week'
                  : schedule.frequency === 'monthly'
                    ? 'month'
                    : 'quarter'}{' '}
              using the filters and columns saved on this report. Timezone:{' '}
              {schedule.timezone || 'America/New_York'}.
            </p>
          </Col>
        </Row>
      )}
    </div>
  )
}
